import { Components, Theme } from '@mui/material';
import { paperClasses } from './types';
import { Border } from '../color';

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: {
      [`&.${paperClasses.brand}`]: {
        border: `2px solid ${Border.brand.main}`,
      },
      [`&.${paperClasses.outlined}`]: {
        border: `1px solid ${Border.variant.main}`,
      },
    },
  },
};
